import { memo } from "react";
import { generatePath } from "react-router";

import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { StepHeader } from "../_step-header";
import { TodoListSectionItem } from "../_todo-list-section-item";
import { TodoListSectionWrapper } from "../_todo-list-section-wrapper";
import { TodoListWrapper } from "../_todo-list-wrapper";
import { START_GUIDE_HOTEL_INFO_ID, START_GUIDE_HOTEL_POLICY_ID } from "../constants";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
};

const HOTEL_INFO_NOT_REGISTERED_MESSAGE = "施設情報の設定をしてください";

export const Step1 = memo(({ startGuide: { hotelID, isHotelInfoRegistered, isHotelPolicyRegistered } }: Props) => {
	return (
		<div className="space-y-4">
			<StepHeader title="Step1" description="施設情報の登録" />
			<p className="text-sm">
				<strong>※</strong> <strong className="text-brand">登録した内容はあとから編集できます</strong>
			</p>

			<TodoListWrapper>
				<TodoListSectionWrapper>
					<TodoListSectionItem
						id={START_GUIDE_HOTEL_INFO_ID}
						title={"施設設定"}
						transitionCondition={true}
						pagePath={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EDIT.DEFAULT, { hotelID })}
						checkBoxStatus={isHotelInfoRegistered}
						requiredTime={3}
						showCheckBox={true}
					/>
					<TodoListSectionItem
						id={START_GUIDE_HOTEL_POLICY_ID}
						title={"ホテルポリシー"}
						transitionCondition={isHotelInfoRegistered}
						alertMessageWhenNotTransition={HOTEL_INFO_NOT_REGISTERED_MESSAGE}
						pagePath={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP, { hotelID })}
						checkBoxStatus={isHotelPolicyRegistered}
						requiredTime={3}
						showCheckBox={true}
					/>
				</TodoListSectionWrapper>
			</TodoListWrapper>
		</div>
	);
});

Step1.displayName = "Step1";
